/**
 * Creates analytics events out of DOM events
 * dispatched by the player
 * @module videoPlayer/analytics/analytics_event
 */

/**
 * Transforms a DOMEvent into an analytics event,
 * extracting the relevant properties from it and
 * adding any extra `data` to them
 * @param {Event} domEvent
 * @param {Object} extraProperties
 * @returns
 */
export function toAnalyticsEvent(domEvent, extraProperties = {}) {
  return {
    name: domEvent.type.replace('sw.', '').replace('.', '_'),
    properties: {
      ...properties(domEvent),
      ...extraProperties
    }
  };
}

function properties(domEvent) {
  const getter = EVENT_PROPERTIES_GETTERS[domEvent.type];
  if (getter) {
    return getter(domEvent);
  }
}

const EVENT_PROPERTIES_GETTERS = {
  'sw.story.start'({ detail }) {
    return {
      variantId: detail.variant.id
    };
  },
  'sw.story.end'({ detail }) {
    return {
      variantId: detail.variant.id
    };
  },
  'sw.variant.start'({ detail }) {
    return {
      variantId: detail.variant.id,
      variantViewingId: detail.variantViewingId
    };
  },
  'sw.variant.progress'({ detail }) {
    return {
      variantId: detail.variant.id,
      variantViewingId: detail.variantViewingId,
      current: detail.current,
      total: detail.total,
      unit: detail.unit
    };
  }
};
